/* Front Line: load a background video only when it is actually displayed (desktop OR mobile variant, not both)
   and within 300px of the viewport. Videos carry data-fl-src instead of src (sections/video-hero, snippets/video). */
(function () {
  var vids = [].slice.call(document.querySelectorAll('video[data-fl-src]'));
  if (!vids.length) return;
  function shown(v) { return v.getClientRects().length > 0 && getComputedStyle(v).visibility !== 'hidden'; }
  function start(v) {
    if (v.getAttribute('src') || !shown(v)) return;
    v.preload = 'auto'; v.src = v.getAttribute('data-fl-src');
    if (v.hasAttribute('autoplay')) {
      var go = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      v.addEventListener('canplay', go, { once: true });   /* play once data is there; an early play() can be dropped */
      v.load(); go();
    }
  }
  if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) start(e.target); }); }, { rootMargin: '300px 0px' });
  vids.forEach(function (v) { io.observe(v); });
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { vids.forEach(function (v) { var r = v.getBoundingClientRect(); if (r.top < innerHeight + 300 && r.bottom > -300) start(v); }); }, 200); });
})();
